/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 */
import { __ } from "@wordpress/i18n";

/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */
import {
	useBlockProps,
	InspectorControls,
	PanelColorSettings,

} from "@wordpress/block-editor";
import {
	Button,
	PanelBody,
	SelectControl,
	ToggleControl,
	TextControl,
} from "@wordpress/components";
import { Fragment, useEffect } from "@wordpress/element";

/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * Those files can contain any CSS code that gets applied to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import "./editor.scss";

/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#edit
 *
 * @return {Element} Element to render.
 */
export default function Edit({ attributes, setAttributes }) {
	const { textColor } = attributes

	const bookingCountTextColor = [
		{
			value: textColor,
			onChange: colorValue => setAttributes({ textColor: colorValue }),
			label: __( "Booking Count Text Color", 'wp-travel-blocks' )
		}
	];

	return (
		<div {...useBlockProps()}>
			<InspectorControls>
				<PanelBody
					title={__("Booking Count Settings", "wp-travel-blocks")}
					initialOpen={true}
				>
					<PanelColorSettings
						title={__('Text Color', 'wp-travel-blocks')}
						colorSettings={bookingCountTextColor}
						initialOpen={false}
					/>
				</PanelBody>
			</InspectorControls>
			<p className="wp-travel-booking-count-block" style={{ color: textColor }}>
				3 people booked this trip.
			</p>
		</div>
	);
}

